import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Glossary from "src/components/HelpMenu/Glossary";
import HelpStandaloneShell from "src/components/HelpMenu/HelpStandaloneShell";

function GlossaryPage() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const { pathname, search, hash } = location;
    if (pathname.length > 1 && pathname.endsWith("/")) {
      navigate(`${pathname.replace(/\/+$/, "")}${search}${hash}`, { replace: true });
    }
  }, [location, navigate]);

  useEffect(() => {
    const htmlEl = document.documentElement;
    const bodyEl = document.body;
    const prevHtmlOverflowY = htmlEl.style.overflowY;
    const prevBodyOverflowY = bodyEl.style.overflowY;
    const prevBodyOverscrollBehavior = bodyEl.style.overscrollBehavior;

    htmlEl.style.overflowY = "auto";
    bodyEl.style.overflowY = "auto";
    bodyEl.style.overscrollBehavior = "auto";

    return () => {
      htmlEl.style.overflowY = prevHtmlOverflowY;
      bodyEl.style.overflowY = prevBodyOverflowY;
      bodyEl.style.overscrollBehavior = prevBodyOverscrollBehavior;
    };
  }, []);

  const handleBack = () => navigate("/");

  return (
    <HelpStandaloneShell title="Glossary" onBack={handleBack}>
      <Glossary standalone handleBack={handleBack} handleClose={handleBack} />
    </HelpStandaloneShell>
  );
}

export default GlossaryPage;
